import { TextLogoCreatePanel } from '../components/panel/text-logo-create-panel.component'
import { useTextLogoCreatePanelViewModel } from '../vmHooks/useTextLogoCreatePanelViewModel'

export function TextLogoCreatePanelWrapper() {
  const vm = useTextLogoCreatePanelViewModel()
  return <TextLogoCreatePanel {...vm} />
}

